import { render, staticRenderFns } from "./OAnnouncements.vue?vue&type=template&id=2c23456a"
import script from "./OAnnouncements.vue?vue&type=script&lang=js"
export * from "./OAnnouncements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports